// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/js/" + chunkId + "." + {"48":"74ffe8d2","64":"f21f75ab","80":"d0405750","205":"83cf6eba","773":"aced1946","850":"c9050026","970":"6135a7fa","985":"3840b47d","996":"22f6d470"}[chunkId] + ".js";
};